var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar-image h-card"},[_c('client-only',[_c('user-avatar',{attrs:{"user":_vm.user,"rounded":true,"fullDetails":_vm.fullDetails,"iconSize":_vm.size,"showBorder":_vm.showBorder,"borderWidth":_vm.borderWidth,"appUrl":_vm.$config.apiBaseURL}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }